import { IHierarchyAPIQuery, IWell, HierarchyLevelType } from 'common/interfaces/hierarchy-entities';
import {
  HierarchyEntityName, deleteHierarchyEntityAPICallAction, getHierarchyEntitiesAPICallAction, getHierarchyEntityAPICallAction, postHierarchyEntityAPICallAction, putHierarchyEntityAPICallAction,
} from '../helpers/hierarchy-api-actions-factory';
import { createHierarchyEntitySlice } from '../../hierarchy-state-slice-factory';

const slice = createHierarchyEntitySlice<IWell>(HierarchyLevelType.Well);

export const {
  itemsRequested: wellsRequested,
  itemsRecieved: wellsRecieved,
  itemsFailed: wellsFailed,
  itemRecieved: wellRecieved,
  itemDeleteRecieved: wellsDeleteRecieved,
} = slice.actions;

export default slice.reducer;

export const getWells = (params: Partial<IHierarchyAPIQuery>) => getHierarchyEntitiesAPICallAction(HierarchyEntityName.WELL, params, wellsRequested.type, wellsFailed.type, wellsRecieved.type);

export const getWell = (entityId: string, parentId: string) => getHierarchyEntityAPICallAction(HierarchyEntityName.WELL, { entityId, parentId }, wellsRequested.type, wellsFailed.type, wellRecieved.type);

export const createWell = (data: Partial<IWell>) => postHierarchyEntityAPICallAction(HierarchyEntityName.WELL, data, wellsRequested.type, wellsFailed.type, wellRecieved.type);

export const updateWell = (data: any) => putHierarchyEntityAPICallAction(HierarchyEntityName.WELL, data.wellid, data, wellsRequested.type, wellsFailed.type, wellRecieved.type);

export const deleteWell = (data: Partial<IWell>) => deleteHierarchyEntityAPICallAction(HierarchyEntityName.WELL, data.wellid!, wellsRequested.type, wellsFailed.type, wellsDeleteRecieved.type);
